import React from 'react';
import PageRenderer from '../../components/common/PageRenderer';

function DefaultContent() {
  return (
    <>
      <section className="relative overflow-hidden bg-[#0B5D1E]" style={{ backgroundImage: 'linear-gradient(135deg, #0B5D1E 0%, #094A18 100%)' }}>
        <div className="relative" style={{ paddingTop: 80, paddingBottom: 80, zIndex: 1 }}>
          <div className="max-w-5xl mx-auto px-4 text-center">
            <h1 style={{ fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#fff', marginBottom: 16, fontFamily: "'Playfair Display',serif" }}>
              Gallery
            </h1>
            <p className="text-white/70 text-lg max-w-2xl mx-auto">
              Photos and highlights from NIS FCT Branch events and activities
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-3 text-center" style={{ fontFamily: "'Playfair Display',serif" }}>Event Highlights</h2>
          <p className="text-gray-500 text-center max-w-2xl mx-auto mb-12">
            A collection of photos from our workshops, seminars, AGMs, and social events
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {['/Surveyor001.jpeg', '/Surveyor002.jpeg', '/Surveyor003.jpeg', '/Surveyor004.jpeg'].map((src, i) => (
              <div key={i} className="relative group overflow-hidden rounded-xl aspect-[4/3] bg-gray-100">
                <img src={src} alt={`NIS FCT Event ${i + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Categories */}
      <section className="py-16 bg-[#F8FAFB]">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl font-bold text-gray-900 mb-10 text-center" style={{ fontFamily: "'Playfair Display',serif" }}>Gallery Categories</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              { icon: '🎤', title: 'Conferences & Seminars', desc: 'Photos from professional conferences, technical workshops, and educational seminars.' },
              { icon: '🏛️', title: 'Annual General Meetings', desc: 'Highlights from our yearly AGMs including elections, reports, and award ceremonies.' },
              { icon: '🤝', title: 'Networking Events', desc: 'Social gatherings, dinners, and networking events bringing members together.' },
              { icon: '🎓', title: 'Training & CPD', desc: 'Workshops and training sessions for continuous professional development.' },
              { icon: '🏆', title: 'Awards & Recognition', desc: 'Celebrations of outstanding contributions by members to the surveying profession.' },
              { icon: '🌍', title: 'Community Outreach', desc: 'Community service activities and public engagement initiatives by the branch.' },
            ].map((item) => (
              <div key={item.title} className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow text-center">
                <div className="text-3xl mb-4">{item.icon}</div>
                <h3 className="text-lg font-bold text-[#0B5D1E] mb-2">{item.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default function Gallery() {
  return <PageRenderer pageKey="gallery" fallback={<DefaultContent />} />;
}
